import type { Actor, ActorType } from '../types/ApprovalActor';

export type ActorKey = string & { readonly __brand: 'ActorKey' };

export const serializeActor = (actor: Actor): ActorKey =>
  `${actor.actorType}:${actor.id}` as ActorKey;

export const parseActor = (key: ActorKey): Actor => {
  const separatorIndex = key.indexOf(':');
  if (separatorIndex === -1) {
    throw new Error(`Malformed ActorKey, expected "<actorType>:<id>": ${key}`);
  }
  return {
    actorType: key.slice(0, separatorIndex) as ActorType,
    id: key.slice(separatorIndex + 1),
  };
};

export const parseActorKeys = (values: string[]): Actor[] =>
  values.map((value) => parseActor(value as ActorKey));
